import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_ElderlyHealth_WeakVisitList({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle2",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const formatDetail = (data) => {
      if (!data) return;

      return data.map((item) => ({
        ...item,
        轉介日期: item["轉介日期"]
          ? moment(item["轉介日期"]).format("YYYY-MM-DD")
          : "-",
        回覆日期: item["回覆日期"]
          ? moment(item["回覆日期"]).format("YYYY-MM-DD")
          : "-",
      }));
    };

    setTbData({
      raw: apiData,
      format: null,
      export: exportData,
      totalRecord,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isPaginator: true,
        callMainAPI,
      })}
    </>
  );
}
